<ps-ui-loader></ps-ui-loader>
<ps-ui-tab-group
  [activeIndex]="activeTabIndex"
  (activeIndexChange)="setActiveTab($event)"
  psUiGtagEvent
  trackOn="click"
  action="survey_tab"
  category="Survey_Tab"
  [params]="{ event_label: 'Manage Survey Tab' }"
>
  <ps-ui-tab
    *ngFor="let tab of tabs; let i = index"
    [label]="tab.title"
    [className]="tab.className"
  >
    <div
      class="menu-content"
      *ngIf="activeTab.key === 'TRAFFIC_CHANNELS' && i === activeTabIndex"
    >
      <ps-ui-manage-traffic-channels
        [survey]="survey"
        [isCpiEditModeDisabled]="isCpiEditModeDisabled"
      ></ps-ui-manage-traffic-channels>
    </div>

    <div
      class="menu-content"
      *ngIf="activeTab.key === 'AUDIENCE' && i === activeTabIndex"
    >
      <ps-ui-manage-audience
        [surveyId]="survey.id"
        [countryCode]="survey.countryCode"
      >
      </ps-ui-manage-audience>
    </div>
    <div
      class="menu-content"
      *ngIf="activeTab.key === 'ACTIVITY_LOGS' && i === activeTabIndex"
    >
      <ps-ui-manage-activity-logs
        [surveyId]="survey.id"
        [isMarginMaxTab]="false"
      ></ps-ui-manage-activity-logs>
    </div>
    <div
      class="menu-content"
      *ngIf="activeTab.key === 'QUOTAS' && i === activeTabIndex"
    >
      <ps-ui-manage-quotas
        [survey]="survey"
        [surveyId]="survey.id"
      ></ps-ui-manage-quotas>
    </div>

    <div
      class="menu-content"
      *ngIf="activeTab.key === 'LINK_OTHER_DETAILS' && i === activeTabIndex"
    >
      <ps-ui-manage-links
        [survey]="survey"
        [surveyId]="survey.id"
      ></ps-ui-manage-links>
    </div>

    <div
      class="menu-content reconcile-content"
      *ngIf="activeTab.key === 'RECONCILE' && i === activeTabIndex"
    >
      <ps-ui-manage-reconcile
        [surveyId]="survey.id"
        [surveyStatus]="survey.status"
      ></ps-ui-manage-reconcile>
    </div>
    <div
      class="menu-content"
      *ngIf="activeTab.key === 'REPORTS' && i === activeTabIndex"
    >
      <div class="container">
        <div class="row">
          <div class="col">
            <ps-ui-manage-report
              [isServiceBuyer]="isServiceBuyerLoggedIn"
              [surveyId]="survey.id"
            ></ps-ui-manage-report>
          </div>
          <div class="col" *ngIf="isServiceBuyerLoggedIn">
            <ps-ui-margin-report [surveyId]="survey.id"></ps-ui-margin-report>
          </div>
        </div>
      </div>
    </div>
    <div
      class="menu-content supplier-tab"
      *ngIf="activeTab.key === 'SUPPLIERS' && i === activeTabIndex"
    >
      <ps-ui-manage-suppliers
        [surveyId]="survey.id"
        [survey]="survey"
      ></ps-ui-manage-suppliers>
    </div>
    <div
      class="menu-content"
      *ngIf="activeTab.key === 'MULTI_COUNTRY' && i === activeTabIndex"
    >
      <ps-ui-manage-multi-country
        [mcUniqueId]="survey.mc_unique_id"
        [surveyId]="survey.id"
      ></ps-ui-manage-multi-country>
    </div>
    <div
      class="menu-content"
      *ngIf="activeTab.key === 'MARGIN_MAX' && i === activeTabIndex"
    >
      <ps-ui-manage-activity-logs
        [surveyId]="survey.id"
        [isMarginMaxTab]="true"
      ></ps-ui-manage-activity-logs>
    </div>
    <div
      class="menu-content"
      *ngIf="activeTab.key === 'HEALTH_CHECKS' && i === activeTabIndex"
    >
      <ps-ui-manage-health-checks [surveyId]="survey.id">
      </ps-ui-manage-health-checks>
    </div>
  </ps-ui-tab>
</ps-ui-tab-group>
